<script>
import { Pie } from "vue-chartjs";
import { API } from "@/api.js";
import { COLORS } from "@/components/colors.js";

export default {
	extends: Pie,
	data: () => ({
		chartdata: {
			labels: [],
			datasets: [
				{
					label: "Data One",
					backgroundColor: COLORS.Tableau20,
					data: [],
				},
			],
		},
		options: {
			responsive: true,
			maintainAspectRatio: true,
			legend: {
				display: true,
				position: "right",
			},
			tooltips: {
				callbacks: {
					label: function (tooltipItem, data) {
						//get the concerned dataset
						var dataset = data.datasets[tooltipItem.datasetIndex];
						//calculate the total of this data set
						var total = dataset.data.reduce(function (
							previousValue,
							currentValue
						) {
							return previousValue + currentValue;
						});
						//get the current items value
						var currentValue = dataset.data[tooltipItem.index];
						//calculate the precentage based on the total and current item, also this does a rough rounding to give a whole number
						var percentage = Math.floor(
							(currentValue / total) * 100 + 0.5
						);
						return percentage + "% (" + currentValue + ")";
					},
				},
			},
		},
	}),
	props: {
		mcode: String,
		field: String, // type oppure machine o pay
	},
	async mounted() {
		let data;
		if (this.field == "pay")
			data = await API.totalAssistanceHoursByType(this.mcode);
		else data = await API.totalAssistanceHours(this.mcode, this.field);
		// console.log("totalAssistanceHours", this.mcode, this.field, data);
		if (this.field == "pay") {
			this.chartdata.labels = ["Paying", "Free", "Included"];
			let ds = this.chartdata.datasets[0];
			ds.data = [0, 0, 0];
			for (let i = 0; i < 3; i++) {
				let d = data
					.filter((d) => d.tipo == this.chartdata.labels[i])
					.reduce((acc, cur) => acc + cur.ore, 0);
				ds.data[i] = d;
				// console.log("d", ds.data);
			}
		} else {
            // inverto l'ordine per avere prima le remote, come gli altri grafici
            // se il campo ticketrem non c'è resta così
            data.sort((a,b) => (b.ticketrem || '').localeCompare((a.ticketrem || '')))
			this.chartdata.labels = data.map((d) => d[this.field]);
			this.chartdata.datasets[0].data = data.map((d) => d.ore);
		}
		let total = data.reduce((acc, d) => acc + d.ore, 0);
		// console.log("emit", total);
		this.$emit("total", total);
        try {
            this.renderChart(this.chartdata, this.options);
        } catch(e){
            // banale errore fake
        }
	},
};
</script>
<style></style>
